export const Archive = () => (
    <>
        <path
            d="M9 12.25C8.58579 12.25 8.25 12.5858 8.25 13C8.25 13.4142 8.58579 13.75 9 13.75H15C15.4142 13.75 15.75 13.4142 15.75 13C15.75 12.5858 15.4142 12.25 15 12.25H9Z"
            fill="black"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.25 5C2.25 4.0335 3.0335 3.25 4 3.25H20C20.9665 3.25 21.75 4.0335 21.75 5V9C21.75 9.41421 21.4142 9.75 21 9.75H20.75V20C20.75 20.9665 19.9665 21.75 19 21.75H5C4.0335 21.75 3.25 20.9665 3.25 20V9.75H3C2.58579 9.75 2.25 9.41421 2.25 9V5ZM19.25 20V9.75H4.75V20C4.75 20.1381 4.86193 20.25 5 20.25H19C19.1381 20.25 19.25 20.1381 19.25 20ZM20.25 8.25H3.75V5C3.75 4.86193 3.86193 4.75 4 4.75H20C20.1381 4.75 20.25 4.86193 20.25 5V8.25Z"
            fill="black"
        />
    </>
);

Archive.viewBox = `0 0 24 24`;
